export const GET_PART_DATA = 'part/GET_PART_DATA'